import * as ACTIONS from '../actions/actionTypes';
const defaultState = {
  isWidgetOpenFirstTime: true,
  liveChatUserInitialPosition: '',
  liveChatUserQueuePosition: '',
  isCustomQueueMessageTriggered: false,
  chipSelection: [],
  additionalComments: '',
  showAdditionalComments: false,
  showOrderTrackingDetail: false,
  shopperId : 0,
  encryptedShopperId : '',
  widgetSessionId : "",
  orderDataExpandedTile: null,
  lastFollowUpEventName: '',
  hasUserInteractedWithBot: false,
  showVocSurvey: false
}
const botData = (state = defaultState, action: any) => {
  switch (action.type) {
    case ACTIONS.IS_WIDGET_OPEN_FIRST_TIME:
      return {
        ...state,
        isWidgetOpenFirstTime: action.isWidgetOpenFirstTime
      }
    case ACTIONS.UPDATE_LC_USER_INITIAL_POSITION:
      return {
        ...state,
        liveChatUserInitialPosition: action.liveChatUserInitialPosition
      }
    case ACTIONS.UPDATE_LC_USER_POSITION:
      return {
        ...state,
        liveChatUserQueuePosition: action.liveChatUserQueuePosition
      }
    case ACTIONS.IS_LC_MESSAGE_TRIGGERED:
      return {
        ...state,
        isCustomQueueMessageTriggered: action.isCustomQueueMessageTriggered
      }
    case ACTIONS.FEEDBACK_CHIP_SELECTION:
        return {
          ...state,
          chipSelection: action.chipSelection
      }
    case ACTIONS.FEEDBACK_ADDITIONAL_COMMENTS:
        return {
          ...state,
          additionalComments: action.additionalComments
      }
    case ACTIONS.SHOW_ORDERTRACKING_DETAIL:
        return {
          ...state,
          showOrderTrackingDetail: action.showOrderTrackingDetail
      }
    case ACTIONS.SHOPPER_ID:
      return {
        ...state,
        shopperId: action.shopperId
    }
    case ACTIONS.ENCRYPTED_SHOPPER_ID:
      return {
        ...state,
        encryptedShopperId: action.encryptedShopperId
    }
    
    case ACTIONS.WIDGET_SESSION_ID:
      return {
        ...state,
        widgetSessionId: action.widgetSessionId
    }
    case ACTIONS.ORDERDATA_EXPANDED_TILE:
      return {
        ...state,
        orderDataExpandedTile: action.orderDataExpandedTile
    }
    case ACTIONS.LAST_FOLLOWUP_EVENT_NAME:
      return {
        ...state,
        lastFollowUpEventName: action.lastFollowUpEventName
    }
    case ACTIONS.HAS_USER_INTERACTED_WITH_BOT:
      return {
        ...state,
        hasUserInteractedWithBot: action.hasUserInteractedWithBot
      }
    case ACTIONS.SHOW_VOC_SURVEY:
      return {
        ...state,
        showVocSurvey: action.showVocSurvey
    }
    default:
      return state
  }
}

export default botData;